import {WebFormModel} from "capitalist-shared/src/core/model";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import axios from "axios";
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";

export class PaymentTemplatesModel extends WebFormModel {

  loadingStatus = new RemoteRequestState();

  loadTemplates(system: string, document: string|number|null = null) {
    this.loadingStatus.loadStart();
    return axios.post('/webapi/finance/payout/templates', {
      call: 'templates',
      system,
      document
    }).then((response) => {
      this.loadingStatus.loadEnd();
      return response.data;
    }).catch((error) => {
      this.loadingStatus.loadError();
      this.checkAxiosError(error);
      throw error;
    });
  }
}

export const fetchPaymentTemplates = async (system: string, document: string|number|null = null) => {
  return httpAxiosApi.post('/webapi/finance/payout/templates', {
    call: 'templates',
    system,
    document
  }).then((response) => {
    return response.data;
  });
}

